/* ============================================================
   OneSupps theme.js — buy box, countdown, FAQ, sticky ATC, cart
   Vanilla JS, no dependencies. Uses Shopify AJAX Cart API.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var hours = parseInt(el.getAttribute('data-hours') || '55', 10);
      var key = 'onesupps_countdown_' + (el.getAttribute('data-id') || 'default');
      var target = parseInt(localStorage.getItem(key) || '0', 10);
      if (!target || target < Date.now()) {
        target = Date.now() + hours * 3600 * 1000;
        localStorage.setItem(key, String(target));
      }
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var ms = Math.max(0, target - Date.now());
        var t = Math.floor(ms / 1000);
        var d = Math.floor(t / 86400);
        var h = Math.floor((t % 86400) / 3600);
        var m = Math.floor((t % 3600) / 60);
        var s = t % 60;
        el.textContent = pad(d) + 'T ' + pad(h) + 'H ' + pad(m) + 'M ' + pad(s) + 'S';
        if (ms <= 0) { clearInterval(iv); }
      }
      tick();
      var iv = setInterval(tick, 1000);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var faq = btn.closest('.faq');
        var panel = faq.querySelector('.faq__a');
        var open = faq.classList.toggle('is-open');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- Stat count-up ---------- */
  function initStats() {
    var stats = document.querySelectorAll('[data-countup]');
    if (!stats.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-countup')) || 0;
        var start = performance.now(), dur = 1400;
        function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.firstChild.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (s) { io.observe(s); });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;
    var onScroll = function () {
      if (window.scrollY > 640) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product gallery (thumbnail swap) ---------- */
  function initGallery() {
    document.querySelectorAll('.product__gallery').forEach(function (gallery) {
      var mainImage = gallery.querySelector('[data-main-image]');
      var thumbs = gallery.querySelectorAll('.product__thumb');
      if (!mainImage || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var newSrc = thumb.getAttribute('data-thumb');
          if (!newSrc) return;
          var img = mainImage.querySelector('img');
          if (img) {
            img.src = newSrc;
            img.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Product buy box ---------- */
  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initBuyBox() {
    var box = document.querySelector('[data-buybox]');
    if (!box) return;

    var bundles = JSON.parse(box.getAttribute('data-bundles') || '[]');
    var subDiscount = parseFloat(box.getAttribute('data-sub-discount') || '15') / 100;
    var hasRealSub = box.getAttribute('data-has-real-sub') === 'true';
    var hasVariantPairs = box.getAttribute('data-has-variant-pairs') === 'true';

    // Read the SERVER-rendered default (which bundle/mode button already has
    // the is-active class) instead of blindly assuming bundles[0] / 'one'.
    // This keeps JS state in sync with what Liquid actually decided to show
    // on first paint (e.g. "2 Dosen" + "Abo" as the approved default).
    var activeMengeEl = box.querySelector('[data-menge].is-active');
    var activeModeEl = box.querySelector('[data-mode].is-active');
    var state = {
      menge: activeMengeEl ? activeMengeEl.getAttribute('data-menge') : (bundles.length ? bundles[0].menge : null),
      mode: activeModeEl ? activeModeEl.getAttribute('data-mode') : 'one',
      sellingPlanId: activeModeEl ? (activeModeEl.getAttribute('data-selling-plan') || null) : null,
      qty: 1
    };

    function currentBundle() {
      return bundles.find(function (b) { return b.menge === state.menge; }) || bundles[0];
    }

    // Resolves what should actually happen for a given bundle under the
    // current mode: which real Shopify variant to use, what its real price
    // is, and (only for real Selling Plans) which selling_plan id to send.
    // Priority: real Selling Plan > real discounted "Abo" variant > (last
    // resort) client-side preview math, which is never used for this
    // product now that real Abo variants exist, but is kept so this section
    // still works on other products that have neither mechanism set up.
    function resolve(b) {
      if (!b) return null;
      if (state.mode !== 'sub') {
        return { variantId: b.one_time.id, price: b.one_time.price, compareAt: b.one_time.compare_at_price, sellingPlan: null };
      }
      if (hasVariantPairs && b.abo) {
        return { variantId: b.abo.id, price: b.abo.price, compareAt: b.abo.compare_at_price, sellingPlan: null };
      }
      if (hasRealSub && state.sellingPlanId) {
        var alloc = (b.one_time.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id == state.sellingPlanId; });
        return { variantId: b.one_time.id, price: alloc ? alloc.price : b.one_time.price, compareAt: b.one_time.compare_at_price, sellingPlan: state.sellingPlanId };
      }
      return { variantId: b.one_time.id, price: Math.round(b.one_time.price * (1 - subDiscount)), compareAt: b.one_time.compare_at_price, sellingPlan: null };
    }

    function render() {
      var b = currentBundle();
      if (!b) return;
      var sel = resolve(b);
      if (!sel) return;

      // bundle highlight + live price on every bundle row (not just the
      // active one) so switching Einmalkauf/Abo updates all quantities.
      box.querySelectorAll('[data-menge]').forEach(function (row) {
        var rowMenge = row.getAttribute('data-menge');
        row.classList.toggle('is-active', rowMenge === state.menge);
        var rowBundle = bundles.find(function (x) { return x.menge === rowMenge; });
        var rowSel = resolve(rowBundle);
        var curEl = row.querySelector('[data-bundle-price-current]');
        var cmpEl = row.querySelector('[data-bundle-price-compare]');
        if (curEl) curEl.textContent = money(rowSel.price);
        if (cmpEl) {
          if (rowSel.compareAt && rowSel.compareAt > rowSel.price) {
            cmpEl.textContent = money(rowSel.compareAt);
            cmpEl.style.display = '';
          } else {
            cmpEl.style.display = 'none';
          }
        }
      });

      // mode highlight
      box.querySelectorAll('[data-mode]').forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-mode') === state.mode);
      });

      // top summary price
      var priceEl = box.querySelector('[data-price-current]');
      var cmpEl2 = box.querySelector('[data-price-compare]');
      var badgeEl = box.querySelector('[data-price-badge]');
      if (priceEl) priceEl.textContent = money(sel.price);
      if (cmpEl2) {
        if (sel.compareAt && sel.compareAt > sel.price) {
          cmpEl2.textContent = money(sel.compareAt);
          cmpEl2.style.display = '';
        } else {
          cmpEl2.style.display = 'none';
        }
      }
      if (badgeEl) {
        if (sel.compareAt && sel.compareAt > sel.price) {
          var pct = Math.round((1 - sel.price / sel.compareAt) * 100);
          badgeEl.textContent = '−' + pct + '%';
        } else {
          badgeEl.textContent = '';
        }
      }

      // qty
      var qtyEl = box.querySelector('[data-qty-value]');
      if (qtyEl) qtyEl.value = state.qty;
      // total on ATC — always price × qty of the currently resolved (real) variant
      var totalEl = box.querySelector('[data-atc-total]');
      if (totalEl) totalEl.textContent = money(sel.price * state.qty);
      // sticky mirror
      var sPrice = document.querySelector('[data-sticky-price]');
      if (sPrice) sPrice.textContent = money(sel.price);

      // Keep the dynamic/express checkout form (payment_button) in sync with
      // the actually selected bundle + purchase mode. This is what makes the
      // Buy Button check out the correct (already-discounted, if Abo) variant
      // instead of always defaulting to variant #1 / Einmalkauf.
      var checkoutVariantInput = document.querySelector('[data-checkout-variant-id]');
      var checkoutPlanInput = document.querySelector('[data-checkout-selling-plan]');
      if (checkoutVariantInput) checkoutVariantInput.value = sel.variantId;
      if (checkoutPlanInput) {
        if (sel.sellingPlan) {
          checkoutPlanInput.value = sel.sellingPlan;
          checkoutPlanInput.disabled = false;
        } else {
          checkoutPlanInput.value = '';
          checkoutPlanInput.disabled = true;
        }
      }
    }

    box.querySelectorAll('[data-menge]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.menge = b.getAttribute('data-menge');
        render();
      });
    });
    box.querySelectorAll('[data-mode]').forEach(function (m) {
      m.addEventListener('click', function () {
        state.mode = m.getAttribute('data-mode');
        state.sellingPlanId = m.getAttribute('data-selling-plan') || null;
        render();
      });
    });
    var inc = box.querySelector('[data-qty-inc]');
    var dec = box.querySelector('[data-qty-dec]');
    if (inc) inc.addEventListener('click', function () { state.qty = Math.min(9, state.qty + 1); render(); });
    if (dec) dec.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });

    function addToCart(btn) {
      var b = currentBundle();
      if (!b) return;
      var sel = resolve(b);
      if (!sel) return;
      var item = { id: sel.variantId, quantity: state.qty };
      if (sel.sellingPlan) {
        // Real Shopify Selling Plan — Shopify itself applies the recurring
        // billing + discount; no manual price math needed.
        item.selling_plan = sel.sellingPlan;
      } else {
        var props = {};
        props['Kaufoption'] = state.mode === 'sub' ? 'Abo (spare ' + Math.round(subDiscount * 100) + '%)' : 'Einmalkauf';
        item.properties = props;
      }
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      }).then(function () {
        if (window.OneSuppsCart) {
          return window.OneSuppsCart.refresh().then(function () {
            window.OneSuppsCart.open();
          });
        }
        window.location.href = '/cart';
      }).catch(function (err) {
        console.error('Add to cart failed', err);
        alert((err && err.description) || 'Der Artikel konnte nicht zum Warenkorb hinzugefügt werden.');
      }).finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
    }

    box.querySelectorAll('[data-atc]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });
    document.querySelectorAll('[data-sticky-atc-btn]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });

    render();
  }

  /* ---------- Cart drawer (right-side slide-in, AJAX) ---------- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]');
    var isOpen = false;

    function escapeHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function itemRow(item) {
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var planLabel = '';
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        planLabel = '<div class="cart-drawer__item-plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</div>';
      } else if (item.properties && item.properties['Kaufoption']) {
        planLabel = '<div class="cart-drawer__item-plan">' + escapeHtml(item.properties['Kaufoption']) + '</div>';
      }
      var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
      return (
        '<div class="cart-drawer__item" data-cart-line="' + item.key + '">' +
          '<div class="cart-drawer__item-media">' + img + '</div>' +
          '<div class="cart-drawer__item-info">' +
            '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>' +
            variantLabel + planLabel +
            '<div class="cart-drawer__item-qty">' +
              '<button type="button" data-cart-qty-dec aria-label="Weniger">−</button>' +
              '<span data-cart-qty-value>' + item.quantity + '</span>' +
              '<button type="button" data-cart-qty-inc aria-label="Mehr">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer__item-actions">' +
            '<div class="cart-drawer__item-price" data-cart-line-price>' + money(item.final_line_price) + '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-cart-remove aria-label="Entfernen">Entfernen</button>' +
          '</div>' +
        '</div>'
      );
    }

    function renderCart(cart) {
      countEls.forEach(function (el) { el.textContent = cart.item_count; });
      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
          '<p>Dein Warenkorb ist noch leer.</p>' +
          '<button type="button" class="btn btn--accent" data-cart-drawer-close>Weiter einkaufen</button></div>';
        if (footer) footer.hidden = true;
        bindEmptyClose();
        return;
      }
      var html = '<div class="cart-drawer__items" data-cart-drawer-items>';
      cart.items.forEach(function (item) { html += itemRow(item); });
      html += '</div>';
      body.innerHTML = html;
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      if (footer) footer.hidden = false;
      bindLineEvents();
    }

    function bindEmptyClose() {
      body.querySelectorAll('[data-cart-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    function bindLineEvents() {
      body.querySelectorAll('[data-cart-line]').forEach(function (row) {
        var key = row.getAttribute('data-cart-line');
        var qtyEl = row.querySelector('[data-cart-qty-value]');
        var inc = row.querySelector('[data-cart-qty-inc]');
        var dec = row.querySelector('[data-cart-qty-dec]');
        var remove = row.querySelector('[data-cart-remove]');
        if (inc) inc.addEventListener('click', function () {
          var q = parseInt(qtyEl.textContent, 10) + 1;
          changeLine(key, q);
        });
        if (dec) dec.addEventListener('click', function () {
          var q = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
          changeLine(key, q);
        });
        if (remove) remove.addEventListener('click', function () { changeLine(key, 0); });
      });
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    function open() {
      isOpen = true;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-lock');
    }

    function close() {
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-lock');
    }

    function toggle() {
      if (isOpen) close(); else { refresh(); open(); }
    }

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        toggle();
      });
    });

    bindLineEvents();

    window.OneSuppsCart = { open: open, close: close, refresh: refresh };
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initFaq();
    initStats();
    initStickyAtc();
    initCartDrawer();
    initBuyBox();
    initGallery();
  });
})();
